import React, {useContext, useEffect, useMemo, useState} from 'react';
import {Context} from '../../../Helpers/Auth';
import {useHistory, useParams} from 'react-router-dom';
import i18n from '../../../i18n';
import {useTranslation} from 'react-i18next';
import {DateTimePicker, LocalizationProvider} from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import ptLocale from 'date-fns/locale/pt';
import frLocale from 'date-fns/locale/fr';
import Datepicker from 'react-tailwindcss-datepicker';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from 'react-toastify';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Spinner from '../../../components/Spinner';
import CameraAltRoundedIcon from '@mui/icons-material/CameraAltRounded';
import QrCode2RoundedIcon from '@mui/icons-material/QrCode2Rounded';
import {QrReader} from 'react-qr-reader';

import SelectComponent from '../../Selects/SelectComponent';
import SelectComponentNotSorted from '../../Selects/SelectComponentNotSorted';

import {GetTipoDespesaMoedas, getVIES, guardarDespesa, getDespesaId, getStatus, putDespesa} from '../../../pages/requests';
import PopUpCamera from '../../popUpCamera';
import ExitForm from '../../ExitFormModal';

function NovaDespesa({buttonClicked, setButtonClicked, onChangeForm, buttonClickedEdit, salvarEdicao, setShowForm, despesa, setOnChangeForm, setButtonClickedEdit}) {
    //const history = useHistory();
    const {t} = useTranslation();
    const [baseImage, setBaseImage] = useState('');
    const [nomeF, setNomeF] = useState();
    const [nif, setNif] = useState('');
    const [moeda, setMoeda] = useState('');
    const [moedas, setMoedas] = useState([]);
    const [tipoDespesas, setTipoDespesas] = useState([]);
    const [dataAtual, setDataAtual] = useState();
    const [startDate, setStartDate] = useState({
        startDate: '2023-09-13',
        endDate: '2023-09-13',
    });
    const [dataFinal, setDataFinal] = useState('');
    const [visibilidade, setVisibilidade] = useState(true);
    const [motivo, setMotivo] = useState();
    const [observacoes, setObservacoes] = useState();
    const [valor, setValor] = useState();
    const [tipoDespesa, setTipoDespesa] = useState('');
    const [checked, setChecked] = React.useState(false);
    const [open3, setOpen3] = React.useState(false);
    const [open2, setOpen2] = React.useState(false);
    const [status, setStatus] = useState('');
    const [statusA, setStatusA] = useState([]);
    const [validacaoValor2, setValidacaoValor2] = useState('');
    const [validacaoNif2, setValidacaoNif2] = useState('');
    const {acessos, rep, utilizador, nome} = useContext(Context);
    const [confirmacaoNifNome, setConfirmacaoNifNome] = useState('');
    const [confirmacaoNifMorada, setConfirmacaoNifMorada] = useState('');
    const [reload, setReload] = useState(0);
    const [editar, setEditar] = useState(true);
    const [loading, setLoading] = useState(false);
    const [moedasOrdenadas, setMoedasOrdenadas] = useState('');
    const [qrData, setQrData] = useState('');
    const [clickQr, setClickQr] = useState(false);

    // Validação

    const [validacaoNome, setValidacaoNome] = useState(false);
    const [validacaoDesc, setValidacaoDesc] = useState(false);
    const [validacaoObs, setValidacaoObs] = useState(false);
    const [validacaoValor, setValidacaoValor] = useState(false);
    const [validacaoMoeda, setValidacaoMoeda] = useState(false);
    const [validacaoDespesa, setValidacaoDespesa] = useState(false);
    const [validacaoNif, setValidacaoNif] = useState(true);

    const [showExitModal, setShowExitModal] = useState(false);

    const [loadingM, setLoadingM] = useState(false);

    const history = useHistory();
    let {id} = useParams();
    const idRecebido = decodeURIComponent(id);

    var today = new Date();

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const [value, setValue] = useState({
        startDate: null,
        endDate: null,
    });

    const handleChange = () => {
        setChecked(!checked);
    };

    const handleLeavePage = event => {
        debugger;
        if (onChangeForm) {
            setShowExitModal(true);
            if (event?.preventDefault) {
                event?.preventDefault();
            }
            return false;
        }
        return true;
    };

    useEffect(() => {
        const unblock = history.block(handleLeavePage);

        window.addEventListener('beforeunload', handleLeavePage);

        return () => {
            unblock();
            window.removeEventListener('beforeunload', handleLeavePage);
        };
    }, [onChangeForm]);

    async function parseQrData(qrData) {
        const contribuinte = qrData.split('A:')[1].split('*')[0];
        const total = qrData.split('O:')[1].split('*')[0];
        const pais = qrData.split('I1:')[1].split('*')[0];

        getVIES(pais, contribuinte).then(e => {
            setNomeF(e.data.vies.nome);
            setOnChangeForm(true);
        });
        setNif(contribuinte);
        setValor(total);
    }

    const handleFiles = async e => {
        const files = e.target?.files[0];

        const base64 = await convertBase64(files);

        setBaseImage(base64);
    };

    const convertBase64 = files => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(files);

            fileReader.onload = () => {
                resolve(fileReader.result);
            };

            fileReader.onerror = error => {
                reject(error);
            };
        });
    };

    const handleClick = () => {
        setOpen3(true);
    };

    const handleClickSuccess = () => {
        setOpen2(true);
    };

    useEffect(() => {
        if (buttonClicked) {
            handleGuardar();
            setButtonClicked(false);
        }
    }, [buttonClicked]);

    useEffect(() => {
        if (buttonClickedEdit) {
            setEditar(false);
            // setButtonClickedEdit(false);
        }
    }, [buttonClickedEdit]);

    useEffect(() => {
        if (salvarEdicao) {
            // alert("aqui")
            EditarDespesa();
            // setButtonClickedEdit(false);
        }
    }, [salvarEdicao]);

    useEffect(() => {
        getStatus(lang).then(res => {
            setStatusA(res.data.status);
        });
        if (despesa) {
            setButtonClickedEdit(false);
            const idDespesa = despesa.id;
            setLoading(true);
            getDespesaId(idDespesa, lang).then(res => {
                if (res.data.success) {
                    res.data.despesas.forEach(element => {
                        const diaI = element.data.slice(0, 2);
                        const mesI = element.data.slice(3, 5);
                        const anoI = element.data.slice(6, 10);

                        const dataF = mesI + '/' + diaI + '/' + anoI;

                        setDataFinal(dataF);
                        setNomeF(element.nome);
                        setNif(element.nif.toUpperCase());
                        setMotivo(element.motivo);
                        setObservacoes(element.observacoes);
                        setValor(element.valor);
                        setChecked(element.terceiros);
                        setMoeda({
                            value: element.moeda,
                            label: element.moeda + ' - ' + element.moedaDesc,
                        });
                        setTipoDespesa({
                            value: element.tipoDespesa,
                            label: element.tipoDespesaDesc,
                        });
                        if (element.foto != '' && element.foto != undefined) {
                            setBaseImage('data:image/jpeg;base64,' + element.foto);
                        }
                        // setStatus({value: element.statusid, label:element.})
                        setStatus({
                            value: parseInt(element.statusid),
                            label: element.status,
                        });
                    });
                    setLoading(false);
                }
            });
            getStatus(lang).then(res => {
                setStatusA(res.data.status);
            });
        } else {
            setDataFinal('');
            setNomeF('');
            setNif('');
            setMotivo('');
            setObservacoes('');
            setValor(0);
            setChecked(false);
            // setMoeda({});
            // setTipoDespesa({});
        }
    }, [despesa]);

    useEffect(() => {
        const idiomaAtual = localStorage.getItem('i18nextLng');
        let lang;
        if (idiomaAtual == 'pt') {
            lang = 'POR';
        } else if (idiomaAtual == 'fr') {
            lang = 'FRA';
        } else if (idiomaAtual == 'en') {
            lang = 'EN';
        }
        GetTipoDespesaMoedas(lang).then(function (response) {
            var comps = [];
            response.data.moedas.forEach(element => {
                const moeda = {
                    value: element.cur,
                    label: element.cur + ' ' + element.curDes,
                };
                comps.push(moeda);
            });
            setMoedas(comps);

            var comps = [];
            response.data.despesas.forEach(element => {
                const Tipodespesa = {
                    value: element.id,
                    label: element.tipo,
                };
                comps.push(Tipodespesa);
            });
            setTipoDespesas(comps);
        });

        var dtToday = new Date();

        var month = dtToday.getMonth() + 1;
        var day = dtToday.getDate();
        var year = dtToday.getFullYear();

        if (month < 10) month = '0' + month.toString();
        if (day < 10) day = '0' + day.toString();

        setDataAtual(year + '-' + month + '-' + day);

        const ano = today.getFullYear();
        const mes = today.getMonth() + 1;
        const dia = today.getDate();
        if (dia < 10 && mes >= 10) {
            setStartDate({
                startDate: mes + '/' + '0' + dia + '/' + ano,
                endDate: mes + '/' + '0' + dia + '/' + ano,
            });
            setDataFinal(ano + '' + mes + '0' + dia);
        } else if (dia >= 10 && mes < 10) {
            setStartDate({
                startDate: '0' + mes + '/' + dia + '/' + ano,
                endDate: '0' + mes + '/' + dia + '/' + ano,
            });
            setDataFinal(ano + '0' + mes + '' + dia);
        } else if (dia < 10 && mes < 10) {
            setStartDate({
                startDate: '0' + mes + '/' + +'0' + dia + '/' + ano,
                endDate: '0' + mes + '/' + +'0' + dia + '/' + ano,
            });
            setDataFinal(ano + '0' + mes + '0' + dia);
        } else if (dia >= 10 && mes >= 10) {
            setStartDate({
                startDate: mes + '/' + dia + '/' + ano,
                endDate: mes + '/' + dia + '/' + ano,
            });
            setDataFinal(ano + '' + mes + '' + dia);
        }
        setVisibilidade(false);
    }, []);

    useEffect(() => {
        const moedasDesejadas = [];
        const outrasMoedas = [];

        moedas.forEach(moeda => {
            if (moeda.value === 'USD' || moeda.value === 'EUR' || moeda.value === 'GBP') {
                moedasDesejadas.push(moeda);
            } else {
                outrasMoedas.push(moeda);
            }
        });
        setMoedasOrdenadas(moedasDesejadas.concat(outrasMoedas));
    }, [moedas]);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen3(false);
    };

    useEffect(() => {
        acessos.forEach(element => {
            if (element.funcao == 'GESYDESPESA') {
                if (element.criar) {
                } else {
                    history.push('/Despesas');
                }
            }
        });
    }, [acessos]);

    const handleDataChange = date => {
        var data = new Date(date.startDate);

        if (data != '' && data != 'Invalid Date' && data != null) {
            const ano = data.getFullYear();
            const mes = data.getMonth() + 1;
            const dia = data.getDate();
            if (dia < 10 && mes >= 10) {
                setDataFinal(ano + '' + mes + '0' + dia);
            } else if (dia >= 10 && mes < 10) {
                setDataFinal(ano + '0' + mes + '' + dia);
            } else if (dia < 10 && mes < 10) {
                setDataFinal(ano + '0' + mes + '0' + dia);
            } else if (dia >= 10 && mes >= 10) {
                setDataFinal(ano + '' + mes + '' + dia);
            }
        } else {
            setDataFinal('');
        }
    };

    useEffect(() => {
        if (nif != '' && nif != undefined) {
            if (nif.length == 11) {
                let countryCode = nif.slice(0, 2);
                let vatNumber = nif.slice(2, 11);

                getVIES(countryCode.toUpperCase(), vatNumber).then(res => {
                    if (res.data.success && res.data.vies.valida) {
                        setConfirmacaoNifNome(res.data.vies.nome);
                        setConfirmacaoNifMorada(res.data.vies.morada);
                    }
                });
            } else {
                setConfirmacaoNifNome('');
                setConfirmacaoNifMorada('');
            }
        } else {
            setConfirmacaoNifNome('');
            setConfirmacaoNifMorada('');
        }
    }, [nif]);

    function handleGuardar() {
        const nifLetras = /^\d+$/.test(nif);
        const qtdLetras = /^[^a-zA-Z]*$/.test(valor);
        const testeCarateres = false;
        setLoadingM(true)
        let terceiros;

        if (checked == true) {
            terceiros = 'true';
        } else {
            terceiros = 'false';
        }
        if (
            nomeF == '' ||
            /*motivo == undefined ||*/ valor == '' ||
            /*observacoes == undefined ||*/ dataFinal == '' ||
            /*baseImage == "''" ||*/ moeda == undefined ||
            tipoDespesa == undefined ||
            tipoDespesa == '' ||
            moeda == '' ||
            qtdLetras == false ||
            testeCarateres == true /*|| nif != undefined*/
        ) {
            // handleClick();
            setLoadingM(false)
            toast.warn(t('camposObrigatorios'), {
                position: 'top-right',
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
            if (nomeF == undefined || nomeF == '') {
                setValidacaoNome(true);
                const data = document.getElementById('nome');
            }
            if (valor == undefined || valor == '') {
                const data = document.getElementById('valor');
            }
            if (dataFinal == '') {
                const data = document.getElementById('data');
            }
            if (motivo == undefined || motivo == '') {
                setValidacaoDesc(true);
            }
            if (observacoes == '') {
                setValidacaoObs(true);
            }
            if (tipoDespesa == undefined || tipoDespesa == '') {
                setValidacaoDespesa(true);
            }
            if (moeda == undefined || moeda == '') {
                setValidacaoMoeda(true);
            }

            if (valor == undefined || valor == '') {
                setValidacaoValor(true);
            }
            if (qtdLetras == false && valor != undefined && valor != '') {
                setValidacaoValor(true);
                setValidacaoValor2(t('validacaoValor'));
            }
            if (qtdLetras == true && valor != undefined && valor != '') {
                setValidacaoValor(false);
                setValidacaoValor2('');
            }
            if (nif != undefined) {
                setValidacaoNif(false);
            }
        }
        const valorMoeda = moeda?.value;
        const valorDespesa = despesa?.value;
        if (
            nomeF != '' &&
            /*motivo != undefined &&*/ valor != undefined &&
            dataFinal != '' &&
            baseImage != "''" &&
            valorMoeda?.length != 0 &&
            valorDespesa?.length != 0 &&
            /*nifLetras == false &&*/ testeCarateres == false &&
            qtdLetras == true
        ) {
            if (nif != undefined) {
                const nifCodigo1 = nif.substring(0, 1);
                const nifCodigo2 = nif.substring(1, 2);
                const verificacaoCodigo1 = /^[^a-zA-Z]*$/.test(nifCodigo1);
                const verificacaoCodigo2 = /^[^a-zA-Z]*$/.test(nifCodigo2);
                //Nif
                const nifRecebido = nif.substring(2, 11);
                const verificacaoNif = /^[^a-zA-Z]*$/.test(nifRecebido);

                //NIF válido
                if (true) {
                    setValidacaoNif(false);
                    setValidacaoNif2('');
                    const guardarConclusaoWS = new Promise((resolve, reject) => {
                        guardarDespesa(nomeF, nif, motivo, valor, dataFinal, baseImage.split(',')[1], utilizador, moeda.value, tipoDespesa.value, observacoes, terceiros, nome)
                            .then(function (res) {
                                if (res.data.success) {
                                    resolve('Sucesso!');
                                } else {
                                    let mensagem = res.error_object.errorMessage;
                                    let resposta = '';
                                    if (mensagem) resposta = mensagem;
                                    if (!mensagem) resposta = t('toastErro');
                                }
                            })
                            .catch(() => reject(t('toastErroServidor')));
                    });
                    toast.promise(
                        guardarConclusaoWS,
                        {
                            // pending: t('a_guardar'),
                            success: {
                                render({data}) {
                                    setLoadingM(false)
                                    history.push('/Despesas');
                                    setShowForm(false);
                                    handleClickSuccess();
                                    return t('despesaRegistada');
                                },
                            },
                            error: {
                                render({data}) {
                                    setLoadingM(false)
                                    return data;
                                },
                            },
                        },
                        {autoClose: 900},
                    );
                }
            } else {
                if (dataFinal != '' && nomeF != '' && valor != undefined && moeda != '' && tipoDespesa != '') {
                    const guardarConclusaoWS = new Promise((resolve, reject) => {
                        guardarDespesa(nomeF, nif, motivo, valor, dataFinal, baseImage.split(',')[1], utilizador, moeda.value, tipoDespesa.value, observacoes, terceiros, nome)
                            .then(function (res) {
                                if (res.data.success) {
                                    resolve('Sucesso!');
                                } else {
                                    let mensagem = res.error_object.errorMessage;
                                    let resposta = '';
                                    if (mensagem) resposta = mensagem;
                                    if (!mensagem) resposta = t('toastErro');
                                    reject(resposta);
                                }
                            })
                            .catch(() => reject(t('toastErroServidor')));
                    });
                    toast.promise(
                        guardarConclusaoWS,
                        {
                            pending: t('a_guardar'),
                            success: {
                                render({data}) {
                                    history.push('/Despesas');

                                    return t('despesaRegistada');
                                },
                            },
                            error: {
                                render({data}) {
                                    return data;
                                },
                            },
                        },
                        {autoClose: 900},
                    );
                }
            }
        }
    }
    function EditarDespesa() {
        if (status != '' && status.value != 0) {
            const idDespesa = despesa.id;
            const guardarConclusaoWS = new Promise((resolve, reject) => {
                putDespesa(idDespesa, status.value)
                    .then(function (res) {
                        if (res.data.success) {
                            resolve('Sucesso!');
                        } else {
                            let mensagem = res.error_object.errorMessage;
                            let resposta = '';
                            if (mensagem) resposta = mensagem;
                            if (!mensagem) resposta = t('toastErro');
                            reject(resposta);
                        }
                    })
                    .catch(() => reject(t('toastErroServidor')));
            });
            toast.promise(
                guardarConclusaoWS,
                {
                    pending: t('a_guardar'),
                    success: {
                        render({data}) {
                            history.push('/Despesas');
                            setShowForm(false);

                            return t('despesaAlterada');
                        },
                    },
                    error: {
                        render({data}) {
                            return data;
                        },
                    },
                },
                {autoClose: 900},
            );
        } else {
            const statusR = document.getElementById('status');
            statusR.style.border = '1px solid red';
            handleClick();
            // alert(t("condicaoStatus"))
        }
    }

    return (
        <>
            {loading && (
                <div className="flex flex-row mt-14 justify-center">
                    <>
                        <Spinner />
                    </>
                </div>
            )}
            {!loading && (
                <form className="mt-4">
                    <div className="grid gap-6 mb-3 md:grid-cols-2">
                        <div>
                            <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('data')}*
                            </label>
                            <Datepicker
                                displayFormat="DD/MM/YYYY"
                                // maxDate={today}
                                useRange={false}
                                asSingle={true}
                                value={startDate}
                                onChange={newValue => {
                                    setStartDate(newValue);
                                    handleDataChange(newValue);
                                    setOnChangeForm(true);
                                }}
                                inputClassName={`rounded-[8px] w-full bg-gray-50 border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                    despesa ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                                }`}
                                disabled={despesa}
                            />
                        </div>
                        <div>
                            <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('nome')}*
                            </label>
                            <input
                                type="text"
                                defaultValue={nomeF}
                                value={nomeF}
                                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                    despesa ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                                } ${validacaoNome ? 'dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''}`}
                                onChange={e => {
                                    setNomeF(e.target.value);
                                    setValidacaoNome(false);
                                    setOnChangeForm(true);
                                }}
                                required
                                disabled={despesa}
                            />
                        </div>
                    </div>
                    <div className="grid gap-6 mb-3 md:grid-cols-3">
                        <div>
                            <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('nif')}
                            </label>
                            <input
                                type="text"
                                value={nif}
                                defaultValue={nif}
                                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                    despesa ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                                }`}
                                onChange={e => {
                                    setNif(e.target.value);
                                    setValidacaoNif(false);
                                    setOnChangeForm(true);
                                }}
                                disabled={despesa}
                            />
                        </div>
                        <div>
                            <label htmlFor="last_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('motivo')}*
                            </label>
                            <input
                                type="text"
                                value={motivo}
                                defaultValue={motivo}
                                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                    despesa ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                                } ${validacaoDesc ? 'dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''}`}
                                onChange={e => {
                                    setMotivo(e.target.value);
                                    setValidacaoDesc(false);
                                    setOnChangeForm(true);
                                }}
                                required
                                disabled={despesa}
                            />
                        </div>
                        <div>
                            <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('observacoes')}*
                            </label>
                            <input
                                type="text"
                                value={observacoes}
                                defaultValue={observacoes}
                                maxLength={50}
                                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                    despesa ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                                } ${validacaoObs ? 'dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''}`}
                                onChange={e => {
                                    setObservacoes(e.target.value);
                                    setValidacaoObs(false);
                                    setOnChangeForm(true);
                                }}
                                required
                                disabled={despesa}
                            />
                        </div>
                        <div>
                            <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('valor')}*
                            </label>
                            <input
                                type="text"
                                value={valor}
                                defaultValue={nif}
                                maxLength={50}
                                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                    despesa ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                                } ${validacaoValor ? 'dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''}`}
                                onChange={e => {
                                    setValor(e.target.value.replace(',', '.'));
                                    setValidacaoValor(false);
                                    setOnChangeForm(true);
                                }}
                                disabled={despesa}
                            />
                        </div>

                        <div>
                            <label htmlFor="website" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('moeda')}*
                            </label>
                            <SelectComponentNotSorted
                                options={moedasOrdenadas}
                                value={moeda}
                                onChange={e => {
                                    setMoeda(e);
                                    setOnChangeForm(true);
                                    setValidacaoMoeda(false);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('selecioneOpcao')}
                                isDisabled={despesa !== null}
                            />
                            {validacaoMoeda && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                        </div>
                        <div>
                            <label htmlFor="visitors" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('tipoDespesa')}*
                            </label>
                            <SelectComponent
                                options={tipoDespesas}
                                value={tipoDespesa}
                                onChange={e => {
                                    setTipoDespesa(e);
                                    setOnChangeForm(true);
                                    setValidacaoDespesa(false);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('selecioneOpcao')}
                                isDisabled={despesa !== null}
                            />
                            {validacaoDespesa && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                        </div>
                    </div>
                    <div className="flex items-center mb-4">
                        <label className="relative inline-flex items-center cursor-pointer">
                            <input
                                type="checkbox"
                                checked={checked}
                                onChange={() => {
                                    handleChange();
                                    setOnChangeForm(true);
                                }}
                                className="sr-only peer"
                                disabled={despesa}
                            />
                            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                            <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('terceiros')}</span>
                        </label>
                    </div>
                    {!despesa && (
                        <div>
                            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white" htmlFor="file_input">
                                {t('carregarFicheiro')}
                            </label>
                            <input
                                className={`block w-full mb-4 text-sm text-gray-900 border border-gray-300 rounded-[8px] cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 ${
                                    despesa ? 'bg-gray-100 dark:bg-gray-800' : 'bg-gray-50 dark:bg-gray-900'
                                }`}
                                id="file_input"
                                type="file"
                                onChange={e => {
                                    handleFiles(e);
                                    setOnChangeForm(true);
                                }}
                            />
                        </div>
                    )}
                    {despesa && (
                        <div
                            onClick={() => {
                                setEditar(false);
                            }}>
                            <label htmlFor="visitors" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('status')}*
                            </label>
                            <SelectComponent
                                isDisabled={editar}
                                options={statusA}
                                value={status}
                                onChange={e => {
                                    setStatus(e);
                                    setOnChangeForm(true);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('selecioneOpcao')}
                            />
                        </div>
                    )}
                    <div style={{marginTop: 10}}>
                        <img src={baseImage} className="h-auto max-w-xs shadow-xl rounded-[8px]" />
                    </div>

                    <div data-dial-init className="fixed right-6 bottom-6 group">
                        <button
                            type="button"
                            title={t('lerQr')}
                            onClick={() => setClickQr(!clickQr)}
                            className="flex items-center  justify-center text-white bg-blue-700 rounded-full w-16 h-16 hover:bg-blue-800 dark:bg-blue-600 dark:hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 focus:outline-none dark:focus:ring-blue-800">
                            <QrCode2RoundedIcon />
                        </button>
                    </div>
                    {clickQr && (
                        <PopUpCamera
                            setQrData={data => {
                                setQrData(data);
                                parseQrData(data);
                            }}
                            back={() => {
                                setClickQr(false);
                            }}
                        />
                    )}
                </form>
            )}
            <ToastContainer />
            {showExitModal && (
                <ExitForm
                    cancelar={() => setShowExitModal(false)}
                    back={() => {
                        setShowForm(false);
                        setShowExitModal(false);
                        setEditar(false);
                    }}
                />
            )}
        </>
    );
}

export default NovaDespesa;
